"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentKlassCodeLogin = void 0;
var _react = _interopRequireWildcard(require("react"));
var _studentLoginBg = _interopRequireDefault(require("../assets/student-login-bg.png"));
var _teacherKlasscodeHelp = _interopRequireDefault(require("../assets/teacher-klasscode-help.png"));
var _KlassCodeInput = require("./KlassCodeInput");
require("./styles.scss");
var _state = require("./../../authSignin/state");
var _pushEventToGTM = require("../../commonHelpers/pushEventToGTM");
var _SuiTurnstile = require("schoolUiComponents/SuiTurnstile");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var StudentKlassCodeLogin = exports.StudentKlassCodeLogin = function StudentKlassCodeLogin() {
  var _useAuthSigninState = (0, _state.useAuthSigninState)(),
    sendEvent = _useAuthSigninState.sendEvent,
    getFromPage = _useAuthSigninState.getFromPage;
  (0, _react.useEffect)(function () {
    if (window.location.hash.includes('student-klasscode')) {
      trackEventsForGuests("Viewed Class Code Input Screen", {
        "mp_login_user_type": "student",
        "From page": getFromPage() || "Direct URL entered"
      }, {
        send_mixpanel: true
      });
    }
    (0, _pushEventToGTM.pushEventToGTM)('viewed_class_code_screen', {
      'Intent for': 'login',
      'Screen type': 'page',
      'From Page': 'signin'
    });
  }, []);
  var userNameLoginClickHandler = function userNameLoginClickHandler() {
    sendInteractedEvent({
      clickedOn: "Login via QR code"
    });
    // trackAnalyticsEvent('Student Login Via username');
    // sendEvent(`Student Login Via username`)
  };
  var sendInteractedEvent = function sendInteractedEvent(_ref) {
    var _ref$interactionDetai = _ref.interactionDetails,
      interactionDetails = _ref$interactionDetai === void 0 ? '' : _ref$interactionDetai,
      _ref$clickedOn = _ref.clickedOn,
      clickedOn = _ref$clickedOn === void 0 ? '' : _ref$clickedOn;
    trackEventsForGuests("Interacted Class Code Input Screen", {
      "mp_login_user_type": "student",
      "Interaction details": interactionDetails,
      "Clicked on": clickedOn
    }, {
      send_mixpanel: true
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_SuiTurnstile.SuiTurnstileProvider, {
    action: "KLASS_CODE_LOGIN",
    userType: "student",
    featureName: _SuiTurnstile.TurnstileEnabledFeature.klass_code_login,
    "data-sentry-element": "SuiTurnstileProvider",
    "data-sentry-component": "StudentKlassCodeLogin",
    "data-sentry-source-file": "KlassCodeLogin.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "login-back",
    onClick: function onClick() {
      sendInteractedEvent({
        clickedOn: "Back Button"
      });
      window.location.hash = "#student";
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "iconcust-iconBackBtn"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login-bg"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _studentLoginBg["default"]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login-body"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, "Enter your Class Code"), /*#__PURE__*/_react["default"].createElement(_KlassCodeInput.KlassCodeInput, {
    "data-sentry-element": "KlassCodeInput",
    "data-sentry-source-file": "KlassCodeLogin.tsx"
  }), /*#__PURE__*/_react["default"].createElement("p", null, "Login via ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "#student-qrcode?fromPage=Class code input screen",
    onClick: userNameLoginClickHandler
  }, "QR code")), /*#__PURE__*/_react["default"].createElement("img", {
    src: _teacherKlasscodeHelp["default"],
    alt: "Don\u2019t know your class code? Ask your teacher for help"
  }))));
};